export default __webpack_public_path__ + "static/media/spaced-logo.0b423e9b.png";